module.exports = __webpack_public_path__ + "static/media/sound_on_icon.2f2b6765.svg";